import { render } from "./WalletView.vue?vue&type=template&id=350eefa2&scoped=true"
import script from "./WalletView.vue?vue&type=script&lang=js"
export * from "./WalletView.vue?vue&type=script&lang=js"

import "./WalletView.vue?vue&type=style&index=0&id=350eefa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350eefa2"]])

export default __exports__